import { useEffect, useState, useRef } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { connect } from 'react-redux';
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { Loader, enumInvoiceState, enumPolicies } from '../../../_metronic/helpers'
import { Button, Row, Col, CardBody, Card, CardFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import Moment from 'react-moment'
import moment from 'moment';
import { Modal } from 'react-bootstrap'
import { AvForm, AvField } from 'availity-reactstrap-validation';
import PolicyChecker from '../../../_metronic/helpers/components/PolicyChecker'
import DocumentPrint from '../common/documentPrint';
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css";
import { Tooltip } from 'bootstrap';
import { useAuth } from "../../modules/auth";

import { MenuComponent } from '../../../_metronic/assets/ts/components'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { getAsync } from '../../../_metronic/helpers/httpClient'
import LanguageSelector from '../../modules/auth/components/LanguageSelector';

import { clearState, getInvoice, getDealers, getCustomers, patchInvoice, postInvoice, putItems, postTransaction, postInvoiceEmail, getHistory, getTransaction, patchTransaction } from './invoiceActions';
import ClientInfoEditor from './ClientInfoEditor';



const InlineEdit = ({ value, renderInput, renderView, readOnly, className }) => {
    const [isEditing, setIsEditing] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (isEditing && containerRef.current) {
            const input = containerRef.current.querySelector('input, textarea');
            if (input) {
                input.focus();
                // Move cursor to the end of the text
                if (['text', 'search', 'url', 'tel', 'password'].includes(input.type) || input.tagName === 'TEXTAREA') {
                    const length = input.value.length;
                    input.setSelectionRange(length, length);
                }
            }
        }
    }, [isEditing]);

    const handleClick = () => {
        if (!readOnly) {
            setIsEditing(true);
        }
    };

    const handleBlur = () => {
        setIsEditing(false);
    };

    return (
        <div
            ref={containerRef}
            onClick={handleClick}
            onBlur={(e) => {
                // Check if the new focus target is still within the current element (e.g. flatpickr calendar)
                // Also check if the related target is a flatpickr calendar element
                const isFlatpickrElement = e.relatedTarget?.closest?.('.flatpickr-calendar');
                if (!e.currentTarget.contains(e.relatedTarget) && !isFlatpickrElement) {
                    handleBlur();
                }
            }}
            className={`${!readOnly && !isEditing ? 'editable-field' : ''} ${className || ''}`}
            style={{ cursor: !readOnly && !isEditing ? 'pointer' : 'default', minHeight: '24px' }}
        >
            {isEditing && !readOnly ? (
                renderInput()
            ) : (
                renderView ? renderView() : <span>{value}</span>
            )}
        </div>
    );
};

const Invoice = (props) => {
    //inputs from url
    const param = useParams();
    const intl = useIntl();
    const navigate = useNavigate();
    const location = useLocation();
    const { currentUser } = useAuth();
    MenuComponent.reinitialization();

    const fpinvoicedate = useRef(null);
    const fpexpirydate = useRef(null);
    const fppaymentdate = useRef(null);
    const fpupdatePaymentdate = useRef(null);

    const [items, setItems] = useState([])
    const [invoiceForm, setInvoiceForm] = useState()
    const [transactionForm, setTransactionForm] = useState()
    const [invoiceDate, setInvoiceDate] = useState(null);
    const [expiryDate, setExpiryDate] = useState(null);
    const [paymentDate, setPaymentDate] = useState(null);
    const [showProcessPaymentModal, setProcessPaymentModal] = useState(false);
    const [showSendEmailModal, setSendEmailModal] = useState(false);
    const [comment, setComment] = useState('');
    const [customContact, setCustomContact] = useState('');
    const [transactionType, setTransactionType] = useState(1);
    const [updatePaymentDate, setUpdatePaymentDate] = useState(null);
    const [updateProcessPaymentModal, setUpdateProcessPaymentModal] = useState(null);
    const [isDirty, setIsDirty] = useState(false);
    const [customerCompany, setCustomerCompany] = useState('');
    const [reference, setReference] = useState('');
    const [orderId, setOrderId] = useState('');
    const [userId, setUserId] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [languages, setLanguages] = useState([]);
    const [invoiceUserLanguageCode, setInvoiceUserLanguageCode] = useState('en');
    const [currentInvoiceEmailLanguageCode, setCurrentInvoiceEmailLanguageCode] = useState('en');
    const [companySettings, setCompanySettings] = useState(null);
    const cdnDomain = process.env.REACT_APP_CDN_DOMAIN



    var componentStyle = `
        .client-info, .company-info {
            min-height: 150px;
            margin-top: 30px;
        }
        .document-title {
            font-size: 22px;
            margin-bottom: 10px;
        }
        .document-details {
            display: flex;
            flex-wrap: wrap;
            gap: 1.5rem;
        }
        .document-details > div {
            margin-bottom: 1rem;
        }
        table.invoice-document-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
        }
        table.invoice-document-table th, table.invoice-document-table td {
            padding: 8px;
            text-align: left;
            border-bottom: 1px solid #ddd;
            vertical-align: top;
        }
        .invoice-row td {
            color: black;
        }
        table.invoice-document-table th {
            background-color: #f2f2f2;
        }
        .total-section td {
            border-bottom: none !important;
        }
        .border-top-solid {
            border-top: 1px solid black !important;
        }
        .editable-field:hover {
            border: 1px dashed #ccc;
            background-color: #f9f9f9;
            border-radius: 4px;
            padding: 2px;
            margin: -3px; /* Compensate for border/padding to avoid layout shift */
        }
        .invoice-row .row-actions {
            visibility: hidden;
        }
        .invoice-row:hover .row-actions {
            visibility: visible;
        }
        .header-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
        .client-info {
            width: 48%;
        }

        @media (max-width: 768px) {
            .client-info, .company-info {
                width: 100%;
                min-height: auto;
                margin-top: 15px;
            }
            .header-container {
                flex-direction: column;
            }
            .invoice-row .row-actions {
                visibility: visible;
            }
        }
    `;

    let tabsModel = [];
    if (param.id == 0) {
        tabsModel = [{
            id: 1,
            name: intl.formatMessage({ id: 'INVOICE.INVOICE' }),
            active: " active",
            hash: "#invoice_tab_1",
            show: 'show',
            policies: [enumPolicies.InvoiceWrite, enumPolicies.InvoiceEdit]
        }]
    } else {
        tabsModel = [
            {
                id: 1,
                name: intl.formatMessage({ id: 'INVOICE.INVOICE' }),
                active: " active",
                hash: "#invoice_tab_1",
                show: 'show',
                policies: [enumPolicies.InvoiceRead, enumPolicies.InvoiceWrite, enumPolicies.InvoiceEdit]
            },
            { id: 3, name: intl.formatMessage({ id: 'INVOICE.HISTORY' }), active: " ", hash: "#invoice_tab_3", show: '', policies: [enumPolicies.InvoiceWrite, enumPolicies.InvoiceEdit] }
        ];
    }

    const [tabs, setTabs] = useState(tabsModel);

    //inputs from redux
    const {
        invoice,
        historyList,
        processPayment,
        success,
        loading,
        historyLoading,
        userList,
        customerList
    } = props;

    //actions
    const {
        clearState,
        getInvoice,
        getDealers,
        getCustomers,
        patchInvoice,
        postInvoice,
        putItems,
        postTransaction,
        postInvoiceEmail,
        getHistory,
        getTransaction,
        patchTransaction
    } = props;

    useEffect(() => {
        const requestLanguages = async () => {
            try {
                const response = await getAsync("/languages")
                if (response && response.data) {
                    setLanguages(response.data.map((item) => {
                        return ({
                            lang: item.code,
                            name: item.name,
                            flag: toAbsoluteUrl(item.icon),
                        })
                    }))
                    MenuComponent.reinitialization();
                }
            } catch (error) {
                console.error(error)
            }
        }
        requestLanguages();

        if (param.id > 0) {
            getInvoice(param.id)
            getHistory(param.id)
        } else {
            setInvoiceDate(moment().format('YYYY-MM-DD'));
            setExpiryDate(moment().add(14, 'days').format('YYYY-MM-DD'));
        }

        if (currentUser && currentUser.policyIds && currentUser.policyIds.some(policy =>
            policy === enumPolicies.UserRead ||
            policy === enumPolicies.UserEdit ||
            policy === enumPolicies.UserWrite)) {
            getDealers();
        }

        if (currentUser && currentUser.policyIds && currentUser.policyIds.some(policy =>
            policy === enumPolicies.CustomerRead ||
            policy === enumPolicies.CustomerEdit ||
            policy === enumPolicies.CustomerWrite)) {
            getCustomers();
        }

        return () => {
            clearState()
        }
    }, []);

    useEffect(() => {
        if (success) {
            toast.success(intl.formatMessage({ id: success }));
        }
    }, [success])

    useEffect(() => {

        if (param.id == 0 && invoice && invoice.id > 0) {
            setTabs(
                [
                    {
                        id: 1,
                        name: intl.formatMessage({ id: 'INVOICE.INVOICE' }),
                        active: " active",
                        hash: "#invoice_tab_1",
                        show: 'show',
                        policies: [enumPolicies.InvoiceRead, enumPolicies.InvoiceWrite, enumPolicies.InvoiceEdit]
                    },
                    { id: 3, name: intl.formatMessage({ id: 'INVOICE.HISTORY' }), active: " ", hash: "#invoice_tab_3", show: '', policies: [enumPolicies.InvoiceWrite, enumPolicies.InvoiceEdit] }
                ]
            )
            navigate(`/order-management/invoices/${invoice.id}?tab=1`);
        }

        if (!invoice?.companyDetailsString) {
            const requestCompanySettings = async () => {
                try {
                    const response = await getAsync("/settings/company");
                    if (response && response.data) {
                        setCompanySettings(response.data);
                    }
                } catch (error) {
                    console.error(error);
                }
            }
            if (currentUser && currentUser.policyIds && currentUser.policyIds.some(policy =>
                policy === enumPolicies.Settings)) {
                requestCompanySettings();
            }
        }

        if (invoice?.customContact) {
            setCustomContact(invoice.customContact)
        }

        if (invoice?.user) {
            setInvoiceUserLanguageCode(invoice.user.languageCode)
            setCurrentInvoiceEmailLanguageCode(invoice.user.languageCode)
        }
        else if (invoice?.customer) {
            setInvoiceUserLanguageCode(invoice.customer.languageCode)
            setCurrentInvoiceEmailLanguageCode(invoice.customer.languageCode)
        }
        else {
            setInvoiceUserLanguageCode('en')
            setCurrentInvoiceEmailLanguageCode('en')
        }

        if (invoice && invoice.invoiceItems) {
            setItems(invoice.invoiceItems);
            setExpiryDate(invoice.expiryDate);
            setInvoiceDate(invoice.invoiceDate);
            setCustomerCompany(invoice.customerCompany);
            setReference(invoice.reference);
            setOrderId(invoice.orderId);
            setCustomerId(invoice.customer === undefined ? null : invoice.customer.id);
            setUserId(invoice.user === undefined ? null : invoice.user.id);
            setIsDirty(false);
        }
    }, [invoice])

    useEffect(() => {
        setUpdatePaymentDate(null);
        setUpdateProcessPaymentModal(false)

        if (processPayment && processPayment.id > 0) {
            setUpdateProcessPaymentModal(true)
        }

    }, [processPayment])

    useEffect(() => {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl)
        })
        return function cleanup() {
            tooltipList.forEach(t => t.dispose())
        };
    }, [invoice]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const tabParam = queryParams.get('tab'); // Query string parametresini alın

        if (tabParam) {
            const updatedTabs = tabsModel.map(tab => ({
                ...tab,
                active: tab.id === parseInt(tabParam) ? "active" : "",
                show: tab.id === parseInt(tabParam) ? "show" : ""
            }));
            setTabs(updatedTabs);
        }
    }, [location.search, param.id]);

    const usersBreadcrumbs = [
        {
            title: intl.formatMessage({ id: 'INVOICES.BREADCRUMB.TITLE' }),
            path: '/order-management/invoices',
            isSeparator: false,
            isActive: false,
        },
        {
            isSeparator: true,
            isActive: false,
        }
    ]

    const validation = {
        required: {
            errorMessage: intl.formatMessage({ id: 'VALIDATION.REQUIRED_FIELD' })
        }
    }

    const emailValidation = {
        required: {
            errorMessage: intl.formatMessage({ id: 'VALIDATION.REQUIRED_FIELD' })
        },
        email: {
            errorMessage: intl.formatMessage({ id: 'VALIDATION.EMAIL_INVALID' })
        }
    }

    const onPrintContent = () => {
        if (invoice && invoice.invoiceItems && invoice.invoiceItems.length > 0) {
            const printDocument = {
                ...invoice,
                customContact: customContact,
                invoiceDate: invoiceDate,
                expiryDate: expiryDate,
                reference: reference,
                customerCompany: customerCompany,
                invoiceItems: items,
                companyDetailsString: invoice.companyDetailsString || companySettings.companyDetailsString
            };

            const markup = renderToStaticMarkup(
                <DocumentPrint document={printDocument} type="invoice" intl={intl} />
            );

            const newTab = window.open('', '_blank');
            newTab.document.write(markup);
            newTab.print();
        }
    }

    const onInvoiceDateChange = ([date]) => {
        var x = moment(date).format('YYYY-MM-DD');
        setInvoiceDate(x);
        setIsDirty(true);
    }

    const onExpiryDateChange = ([date]) => {
        var x = moment(date).format('YYYY-MM-DD');
        setExpiryDate(x);
        setIsDirty(true);
    }

    const onPaymentDateChange = ([date]) => {
        var x = moment(date).format('YYYY-MM-DD');
        setPaymentDate(x);
    }

    const handleInvoiceValidSubmit = (event, values) => {
        // Convert relationshipNr to number
        values.relationshipNr = Number(values.relationshipNr);
        if (param.id > 0) {
            patchInvoice(param.id, {
                invoiceDate: {
                    set: true,
                    value: invoiceDate
                },
                expiryDate: {
                    set: true,
                    value: expiryDate
                },
                reference: {
                    set: true,
                    value: reference
                },
                customerCompany: {
                    set: true,
                    value: customerCompany
                },
                customContact: {
                    set: true,
                    value: customContact
                },
                userId: {
                    set: true,
                    value: userId !== null ? parseInt(userId) : -1
                },
                customerId: {
                    set: true,
                    value: customerId !== null ? parseInt(customerId) : -1
                },
            }).then(response => {
                putItems(param.id, items)
            })
        } else {
            postInvoice({
                invoiceDate: invoiceDate,
                expiryDate: expiryDate,
                reference: reference,
                customerCompany: customerCompany,
                customContact: customContact,
                userId: userId,
                customerId: customerId
            }).then(response => {
                if (response && response.isSuccess && response.data && response.data.id) {
                    putItems(response.data.id, items)
                }
            })
        }
    }

    const onInputChange = (index, value, type) => {
        var xAmounts = [...items];
        for (let i = 0; i < xAmounts.length; i++) {

            if (xAmounts[i].show == false) {
                xAmounts[i].quantity = 0;
                xAmounts[i].unitPrice = 0;
                xAmounts[i].totalPrice = 0;
                continue;
            }

            if (i == index) {
                if (type == 1) {
                    xAmounts[i].quantity = value;
                    xAmounts[i].totalPrice = xAmounts[i].unitPrice * value;
                }
                if (type == 2) {
                    xAmounts[i].unitPrice = value;
                    xAmounts[i].totalPrice = xAmounts[i].quantity * value;
                }
                if (type == 3) {
                    xAmounts[i].vat = value;
                }
            }
        }
        setItems(xAmounts);
        setIsDirty(true);
    }

    const getTotals = (type) => {
        var total = 0;
        if (type == 1) {
            items.filter(x => x.show != false).map((item) => {
                total += item.totalPrice;
            })
        }
        if (type == 2) {
            items.filter(x => x.show != false).map((item) => {
                total += item.totalPrice * item.vat / 100;
            })
        }
        if (type == 3) {
            items.filter(x => x.show != false).map((item) => {
                total += item.totalPrice + (item.totalPrice * item.vat / 100);
            })
        }
        return total.toFixed(2);
    }

    const onPaymentClick = () => {
        setProcessPaymentModal(true);
    }

    const onSendEmailClick = () => {
        setCurrentInvoiceEmailLanguageCode(invoiceUserLanguageCode)
        setSendEmailModal(true);
    }

    const handleTransactionValidSubmit = (event, values) => {

        var xdate = paymentDate ? paymentDate : moment().format('YYYY-MM-DD');

        postTransaction(param.id, {
            transactionAmount: values.transactionAmount,
            transactionDate: xdate
        })
        setProcessPaymentModal(false);
        transactionForm.reset();
    }

    const handleSendEmailSubmit = (event, values) => {
        postInvoiceEmail(param.id, {
            EmailTo: values.emailAddress,
            LanguageCode: currentInvoiceEmailLanguageCode
        })
        setSendEmailModal(false);
    }

    const addComment = () => {
        if (comment == '') return;
        patchInvoice(param.id, {
            note: {
                set: true,
                value: comment
            }
        })
        setComment('')
    }

    const handleDescriptionChange = (index, e) => {
        var xItems = [...items];
        xItems[index].description = e.target.value;
        setItems(xItems);
        setIsDirty(true);
    }

    const getRows = (text) => {
        if (text)
            return text.split('\n').length + 1;

        return 2;
    }

    const onTransactionTypeChange = (type) => {
        setTransactionType(type);
    }

    const onHistoryClick = (history) => {
        if (history.tableName == 'InvoiceTransaction') {
            getTransaction(param.id, history.identifier);
        } else if (history.tableName == 'Quote') {
            navigate(`/order-management/quotes/${history.identifier}`);
        }
    }

    const onUpdatePaymentDateChange = ([date]) => {
        var x = moment(date).format('YYYY-MM-DD');
        setUpdatePaymentDate(x);
    }

    const handleUpdateTransactionValidSubmit = (event, values) => {
        const xdate = updatePaymentDate ? updatePaymentDate : processPayment.transactionDate;
        patchTransaction(param.id, processPayment.id, {
            transactionDate: xdate
        })
    }

    const handleLanguageChange = (language) => {
        setCurrentInvoiceEmailLanguageCode(language.lang)
    };

    const renderTransactions = () => {
        if (invoice && invoice.paidAmount > 0 && invoice.paidAmount < getTotals(3)) {

            return (
                <>

                    <tr>
                        <td colSpan={3}></td>
                        <td className="text-end pe-5">
                            {intl.formatMessage({ id: 'INVOICE.ALREADY_PAID' })}:
                        </td>
                        <td className="text-start">
                            € {Number(invoice.paidAmount).toFixed(2)}
                        </td>
                        <td>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3}></td>
                        <td className="text-end pe-5">
                            {intl.formatMessage({ id: 'INVOICE.OUTSTANDING' })}:
                        </td>
                        <td className="text-start">
                            € {(getTotals(3) - invoice.paidAmount).toFixed(2)}
                        </td>
                        <td>
                        </td>
                    </tr>

                </>
            )
        }
    }

    const getColors = (status, name) => {
        switch (status) {
            case 1:
                return <span className="badge badge-light-warning">{name}</span>
            case 2:
                return <span className="badge badge-light-success">{name}</span>
            case 3:
                return <span className="badge badge-light-danger">{name}</span>
            case 4:
                return <span className="badge badge-light-dark">{name}</span>
            default:
                return <span className="badge badge-light-primary">{name}</span>
        }
    }

    const isInvoiceImmutable = () => {
        return invoice?.invoiceState === enumInvoiceState.Paid ||
            invoice?.invoiceState === enumInvoiceState.Open ||
            invoice?.invoiceState === enumInvoiceState.Expired;
    }

    const renderPaymentIcon = () => {
        if (invoice?.invoiceState !== enumInvoiceState.Paid) {
            return (
                <>
                    <i className={`ki-duotone ki-euro fs-3x mr-5 cursor-pointer`} onClick={() => onPaymentClick()} data-bs-toggle="tooltip" title={intl.formatMessage({ id: "INVOICE.MODAL.PROCESS_PAYMENT" })}>
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                    </i>
                </>
            );
        }

        return null;
    }

    const renderOrderIcon = () => {
        if (invoice?.orderId > 0) {
            return (
                <>
                    <i className={`ki-duotone ki-delivery-2 fs-3x mr-5 cursor-pointer`} onClick={() => navigate(`/order-management/orders/${invoice.orderId}`)} data-bs-toggle="tooltip" title={intl.formatMessage({ id: "ORDER.MANAGEMENT.ORDER_TITLE" })}>
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                        <span className="path5"></span>
                        <span className="path6"></span>
                        <span className="path7"></span>
                        <span className="path8"></span>
                        <span className="path9"></span>
                    </i>
                </>
            );
        }

        return null;
    }

    const renderSendEmailIcon = () => {
        if (currentUser && currentUser.policyIds && currentUser.policyIds.some(policy =>
            policy === enumPolicies.InvoiceEdit ||
            policy === enumPolicies.InvoiceWrite)) {
            return (
                <>
                    <i className={`ki-duotone fonticon-mail fs-3x mr-5 cursor-pointer`} onClick={() => onSendEmailClick()} data-bs-toggle="tooltip" title={intl.formatMessage({ id: "INVOICE.MODAL.SEND_EMAIL" })}></i>
                </>
            );
        }
        return null;
    }

    const renderPrintIcon = () => {
        return (
            <>
                <i className={`ki-duotone ki-printer fs-3x mr-5 cursor-pointer`} onClick={() => onPrintContent()} data-bs-toggle="tooltip" title={intl.formatMessage({ id: "GENERAL.PRINT" })}>
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                    <span className="path4"></span>
                    <span className="path5"></span>
                </i>
            </>
        );
    }

    const renderSummaryToolbar = () => {
        if (invoice && invoice.id > 0 && param.id > 0) {
            return (
                <div className="card-toolbar">
                    <div className="d-flex flex-end rounded-3 mt-5">
                        {renderPaymentIcon()}
                        {renderOrderIcon()}
                        {renderSendEmailIcon()}
                        {renderPrintIcon()}
                    </div>
                </div>
            )
        }
    }

    const renderFlatpickr = (ref, onChange, value, placeholder, isReadOnly) => {
        if (isReadOnly === true) {
            return (
                <input
                    type="text"
                    value={value}
                    className="form-control"
                    readOnly
                    placeholder={placeholder}
                />
            )

        } else {
            return (
                <Flatpickr ref={ref}
                    onChange={onChange}
                    options={{
                        dateFormat: "d-m-Y",
                    }}
                    value={value}
                    className='form-control'
                    placeholder={placeholder}
                />
            )
        }
    }



    const moveRow = (index, direction) => {
        const newItems = [...items];
        const targetIndex = direction === 'up' ? index - 1 : index + 1;

        // Swap items
        [newItems[index], newItems[targetIndex]] = [newItems[targetIndex], newItems[index]];

        // Update sortOrder based on the new order
        const updatedItems = newItems.map((item, idx) => ({
            ...item,
            sortOrder: idx + 1, // Set sortOrder to match the current index
        }));

        setItems(updatedItems);
        setIsDirty(true);
    };

    const removeItem = (index) => {
        const newItems = items.filter((_, i) => i !== index);

        // Update sortOrder based on the new order
        const updatedItems = newItems.map((item, idx) => ({
            ...item,
            sortOrder: idx + 1, // Set sortOrder to match the current index
        }));

        setItems(updatedItems);
        setIsDirty(true);
    };

    const addItem = () => {
        var newItem = {
            id: "0",
            description: '',
            unitPrice: 0,
            totalPrice: 0,
            vat: 0,
            sortOrder: items.length + 1,
            show: true
        }
        var newItems = [...items, newItem];
        setItems(newItems)
        setIsDirty(true);
    };

    const renderInvoice = () => {
        var tab = tabs.find(x => x.id == 1);
        if (!tab) return null;

        return (
            <div className={`tab-pane fade ${tab.active} ${tab.show}`} id={tab.hash.replace('#', '')} role="tab-panel">
                <style>
                    {componentStyle}
                </style>
                <div className="d-flex flex-column gap-7 gap-lg-10">
                    <div className="card ">
                        <div className="card-header">
                            <div className="card-title">
                                <h2>{intl.formatMessage({ id: "INVOICE.INVOICE" })} - (#{invoice && invoice.invoiceNr}) {invoice && getColors(invoice.invoiceState, invoice.invoiceStateName)}</h2>
                            </div>
                            {renderSummaryToolbar()}
                        </div>
                        <div className="card-body">
                            <AvForm key={1} onValidSubmit={handleInvoiceValidSubmit} ref={(e) => (setInvoiceForm(e))}>
                                <div className="container" style={{ width: "100%", padding: "0" }}>
                                    <div className="logo mb-5">
                                        <img src={`${cdnDomain}/company/logo.png`} width={300} alt="logo" />
                                    </div>
                                    <div className="header-container">
                                        <div className="company-info">
                                            {
                                                (invoice?.companyDetailsString) ? (
                                                    <div dangerouslySetInnerHTML={{ __html: invoice?.companyDetailsString?.replace(/\n/g, '<br />') }}></div>
                                                ) : (
                                                    <div dangerouslySetInnerHTML={{ __html: companySettings?.companyDetailsString?.replace(/\n/g, '<br />') }}></div>
                                                )
                                            }
                                        </div>
                                        <div className="client-info">
                                            <ClientInfoEditor
                                                userList={userList}
                                                customerList={customerList}
                                                initialUserId={userId}
                                                initialCustomerId={customerId}
                                                initialCustomContact={customContact}
                                                isReadOnly={isInvoiceImmutable() || (invoice?.orderId && invoice.orderId > 0)}
                                                onChange={(data) => {
                                                    setCustomContact(data.customContact);
                                                    setUserId(data.userId);
                                                    setCustomerId(data.customerId);
                                                    setCustomerCompany(data.customerCompany);
                                                    setIsDirty(true);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="document-title">
                                        {intl.formatMessage({ id: 'PRINT.INVOICE' })}
                                    </div>

                                    <div className="document-details">
                                        <div className="me-5">
                                            <strong>{intl.formatMessage({ id: 'PRINT.INVOICE_NUMBER' })}</strong>
                                            <br />
                                            <span>{invoice && invoice.invoiceNr}</span>
                                            <AvField name="invoiceNr" type="hidden" value={invoice && invoice.invoiceNr} />
                                        </div>
                                        <div className="me-5">
                                            <strong>{intl.formatMessage({ id: 'PRINT.INVOICE_DATE' })}</strong>
                                            <br />
                                            <InlineEdit
                                                key={`invoice-date-${invoiceDate}`}
                                                readOnly={isInvoiceImmutable()}
                                                value={invoiceDate && moment(invoiceDate).format('DD-MM-YYYY')}
                                                renderInput={() => (
                                                    renderFlatpickr(
                                                        fpinvoicedate,
                                                        onInvoiceDateChange,
                                                        invoiceDate && moment(invoiceDate).format('DD-MM-YYYY'),
                                                        'Select Invoice Date',
                                                        isInvoiceImmutable())
                                                )}
                                            />
                                        </div>
                                        <div className="me-5">
                                            <strong>{intl.formatMessage({ id: 'PRINT.INVOICE_EXPIRE_DATE' })}</strong>
                                            <br />
                                            <InlineEdit
                                                key={`expiry-date-${expiryDate}`}
                                                readOnly={isInvoiceImmutable()}
                                                value={expiryDate && moment(expiryDate).format('DD-MM-YYYY')}
                                                renderInput={() => (
                                                    renderFlatpickr(
                                                        fpexpirydate,
                                                        onExpiryDateChange,
                                                        expiryDate && moment(expiryDate).format('DD-MM-YYYY'),
                                                        'Select Expiry Date',
                                                        isInvoiceImmutable())
                                                )}
                                            />
                                        </div>
                                        {
                                            (invoice && invoice?.customer?.relationshipNr > 0) && (
                                                <div className="me-5">
                                                    <strong>{intl.formatMessage({ id: 'PRINT.INVOICE_RELATIONSHIPNR' })}</strong>
                                                    <br />
                                                    <span>{invoice?.customer?.relationshipNr}</span>
                                                    <AvField name="relationshipNr" type="hidden" value={invoice?.customer?.relationshipNr} />
                                                </div>
                                            )
                                        }
                                        {
                                            (orderId > 0) && (
                                                <div className="me-5">
                                                    <strong>{intl.formatMessage({ id: 'PRINT.INVOICE_ORDER_NUMBER' })}</strong>
                                                    <br />
                                                    <InlineEdit
                                                        readOnly={true}
                                                        value={orderId}
                                                        renderInput={() => (
                                                            <AvField name="orderId" type="number" value={orderId} validate={validation} />
                                                        )}
                                                    />
                                                </div>
                                            )
                                        }
                                        <div className="me-5">
                                            <strong>{intl.formatMessage({ id: 'INVOICE.FIELD.REFERENCE' })}</strong>
                                            <br />
                                            <InlineEdit
                                                readOnly={isInvoiceImmutable()}
                                                value={reference}
                                                renderInput={() => (
                                                    <AvField name="reference" type="text" value={reference} validate={validation} onChange={(e) => { setReference(e.target.value); setIsDirty(true); }} />
                                                )}
                                            />
                                        </div>
                                    </div >
                                    <div className="table-responsive">
                                        <table className="invoice-document-table">
                                            <thead>
                                                <tr>
                                                    <th className="w-75px">{intl.formatMessage({ id: "INVOICE.FIELD.QUANTITY" })}</th>
                                                    <th className="w-400px">{intl.formatMessage({ id: "INVOICE.FIELD.DESCRIPTION" })}</th>
                                                    <th className="w-100px">{intl.formatMessage({ id: "INVOICE.FIELD.PRICE" })}</th>
                                                    <th className="w-100px">{intl.formatMessage({ id: "INVOICE.FIELD.AMOUNT" })}</th>
                                                    <th className="w-75px">{intl.formatMessage({ id: "INVOICE.FIELD.VAT" })}</th>
                                                    <th className="w-125px"></th>
                                                </tr>
                                            </thead>
                                            <tbody className="fw-semibold text-gray-600">
                                                {items && items.map((item, index) => {
                                                    if (item.show == false) {
                                                        return null;
                                                    }
                                                    return (
                                                        <tr key={`invoce_item_${index}`} className="invoice-row">
                                                            <td>
                                                                <InlineEdit
                                                                    readOnly={isInvoiceImmutable()}
                                                                    value={item.quantity}
                                                                    renderInput={() => (
                                                                        <AvField name={`items[${index}].quantity`} type="number" value={item.quantity} validate={validation} className="hide-arrow"
                                                                            onChange={(e) => onInputChange(index, e.target.value, 1)} />
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>
                                                                <InlineEdit
                                                                    readOnly={isInvoiceImmutable()}
                                                                    value={item.description}
                                                                    renderInput={() => (
                                                                        <AvField name={`items[${index}].description`} rows={getRows(item.description)} type="textarea" value={item.description} validate={validation}
                                                                            onChange={(e) => handleDescriptionChange(index, e)} />
                                                                    )}
                                                                    renderView={() => (
                                                                        <div dangerouslySetInnerHTML={{ __html: item.description ? item.description.replace(/\n/g, '<br />') : '' }}></div>
                                                                    )}
                                                                />
                                                                <AvField type="hidden" name={`items[${index}].id`} value={item.id} />
                                                                <AvField type="hidden" name={`items[${index}].sortOrder`} value={item.sortOrder} />
                                                            </td>
                                                            <td>
                                                                <InlineEdit
                                                                    readOnly={isInvoiceImmutable()}
                                                                    value={`€ ${item.unitPrice}`}
                                                                    renderInput={() => (
                                                                        <AvField name={`items[${index}].unitPrice`} type="number" value={item.unitPrice} validate={validation} className="hide-arrow"
                                                                            onChange={(e) => onInputChange(index, e.target.value, 2)} />
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>
                                                                <span>€ {Number(item.totalPrice).toFixed(2)}</span>
                                                                <AvField name={`items[${index}].totalPrice`} type="hidden" value={item.totalPrice} />
                                                            </td>
                                                            <td>
                                                                <InlineEdit
                                                                    readOnly={isInvoiceImmutable()}
                                                                    value={`${item.vat}%`}
                                                                    renderInput={() => (
                                                                        <AvField name={`items[${index}].vat`} type="number" value={item.vat} validate={validation} className="hide-arrow"
                                                                            onChange={(e) => onInputChange(index, e.target.value, 3)} />
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>
                                                                {
                                                                    !isInvoiceImmutable() &&
                                                                    <div className="row-actions d-flex gap-1">
                                                                        <Button
                                                                            className="btn-icon btn-active-light-primary w-30px h-30px"
                                                                            color="light"
                                                                            onClick={() => moveRow(index, 'up')}
                                                                            disabled={index === 0}
                                                                        >
                                                                            <i className="bi bi-arrow-up-short fs-3"></i>
                                                                        </Button>
                                                                        <Button
                                                                            className="btn-icon btn-active-light-primary w-30px h-30px"
                                                                            color="light"
                                                                            onClick={() => moveRow(index, 'down')}
                                                                            disabled={index === items.length - 1}
                                                                        >
                                                                            <i className="bi bi-arrow-down-short fs-3"></i>
                                                                        </Button>
                                                                        <Button
                                                                            className="btn-icon btn-active-light-danger w-30px h-30px"
                                                                            color="light"
                                                                            onClick={() => { removeItem(index) }}
                                                                        >
                                                                            <i className="bi bi-trash fs-3"></i>
                                                                        </Button>
                                                                    </div>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                                <tr>
                                                    <td colSpan={6} className="p-0">
                                                        {
                                                            !isInvoiceImmutable() &&
                                                            <div
                                                                className="d-flex align-items-center justify-content-center p-2 my-4 rounded cursor-pointer opacity-75 hover-opacity-100"
                                                                style={{ border: '1px dashed #ccc', backgroundColor: '#f9f9f9' }}
                                                                onClick={() => { addItem() }}
                                                            >
                                                                <i className="bi bi-plus-lg me-2 text-gray-600"></i>
                                                                <span className="text-gray-600 fw-bold">{intl.formatMessage({ id: 'INVOICE.ADD_ITEM' })}</span>
                                                            </div>
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot className="total-section">
                                                <tr>
                                                    <td colSpan={3}></td>
                                                    <td className="text-end pe-5">{intl.formatMessage({ id: 'INVOICE.TOTAL_EXCLUDING_VAT' })}</td>
                                                    <td className="text-start">€ {getTotals(1)}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={3}></td>
                                                    <td className="text-end pe-5">{intl.formatMessage({ id: 'INVOICE.TOTAL_VAT' })}</td>
                                                    <td className="text-start">€ {getTotals(2)}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={3}></td>
                                                    <td className="text-end pe-5 bold border-top-solid">{intl.formatMessage({ id: 'INVOICE.TOTAL_INCLUDING_VAT' })}</td>
                                                    <td className='text-start border-top-solid'>€ {getTotals(3)}</td>
                                                    <td className="border-top-solid"></td>
                                                </tr>
                                                {renderTransactions()}
                                            </tfoot>
                                        </table>
                                    </div>

                                    {
                                        !isInvoiceImmutable() &&
                                        <Row className='mt-10'>
                                            <Col>
                                            </Col>
                                            <Col className='text-end'>
                                                <AvField type="hidden" name="id" value={invoice && invoice.id} />
                                                {isDirty && <Button color="success" type="submit">{intl.formatMessage({ id: 'INVOICE.SAVE' })}</Button>}
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            </AvForm>
                        </div>
                    </div >
                </div >
            </div >
        )
    }

    const renderHistory = () => {
        if (invoice && invoice.id > 0 && param.id > 0) {
            var tab = tabs.find(x => x.id == 3);

            return (
                <div className={`tab-pane fade ${tab.active} ${tab.show}`} id={tab.hash.replace('#', '')} role="tab-panel">
                    <div className="d-flex flex-column gap-7 gap-lg-10">
                        <div className="card card-flush py-4 flex-row-fluid">
                            <div className="card-header">
                                <div className="card-title">
                                    <h2>{intl.formatMessage({ id: "ORDER.FIELD.HISTORY" })} {invoice && getColors(invoice.invoiceState, invoice.invoiceStateName)}</h2>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th className="min-w-100px">{intl.formatMessage({ id: "ORDER.FIELD.USER" })}</th>
                                                <th className="min-w-175px">{intl.formatMessage({ id: "ORDER.FIELD.COMMENT" })}</th>
                                                <th className="min-w-100px">{intl.formatMessage({ id: "ORDER.FIELD.DATE" })}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600">
                                            {historyList && historyList.map((history, index) => {
                                                return (
                                                    <tr key={`history_row_${index}`}>
                                                        <td>{history.userName}</td>
                                                        <td
                                                            className={`${history.tableName === "InvoiceTransaction" || history.tableName === "Quote" ?
                                                                "cursor-pointer hover:text-primary-light" : ""}`}
                                                            onClick={() => onHistoryClick(history)}
                                                            style={{ whiteSpace: 'pre-line' }}
                                                        >
                                                            {history.fieldName}
                                                        </td>
                                                        <td><Moment format="DD-MM-YYYY">{history.date}</Moment></td>
                                                    </tr>
                                                )
                                            })}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <CardFooter className="p-5">
                                <div className="input-group">
                                    <textarea
                                        className='form-control'
                                        rows={1}
                                        onChange={(e) => setComment(e.target.value)}
                                        value={comment}
                                        placeholder={intl.formatMessage({ id: "INVOICE.HISTORY.ADD_NOTE" })}
                                        style={{ resize: 'none' }}
                                    />
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => addComment()}
                                        disabled={!comment.trim()}
                                    >
                                        <i className="ki-duotone ki-send fs-2">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </button>
                                </div>
                            </CardFooter>
                        </div>
                    </div>
                    {historyLoading && <Loader />}
                </div>
            )
        }
    }

    const renderProcessPaymentModal = () => {

        return (
            <Modal centered show={showProcessPaymentModal} onHide={() => setProcessPaymentModal(!showProcessPaymentModal)}>
                <Modal.Header closeButton>
                    <Modal.Title>{intl.formatMessage({ id: 'INVOICE.MODAL.PROCESS_PAYMENT' })}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="py-5 mb-5">
                        <Row>
                            <Col>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" value="1" id="transactionType1" name="transactionType" checked={transactionType == 1}
                                        onChange={() => onTransactionTypeChange(1)} />
                                    <label className="form-check-label" htmlFor="transactionType1">
                                        {intl.formatMessage({ id: 'INVOICE.MODAL.FULL_PAYMENT' })}
                                    </label>
                                </div>
                            </Col>
                            <Col>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" value="2" id="transactionType2" name="transactionType" checked={transactionType == 2}
                                        onChange={() => onTransactionTypeChange(2)} />
                                    <label className="form-check-label" htmlFor="transactionType2">
                                        {intl.formatMessage({ id: 'INVOICE.MODAL.PARTIAL_PAYMENT' })}
                                    </label>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <AvForm key={1} onValidSubmit={handleTransactionValidSubmit} ref={(e) => (setTransactionForm(e))}>
                        <Row>
                            <Col>
                                <AvField name="invoiceNr" label={intl.formatMessage({ id: 'INVOICE.FIELD.NUMBER' })} type="text" value={invoice && invoice.invoiceNr} readOnly={true}
                                    className="form-control-solid" />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {transactionType == 2 &&
                                    <AvField name="transactionAmount" label={intl.formatMessage({ id: 'INVOICE.MODAL.AMOUNT_RECEIVED' })} type="number" validate={validation} className='hide-arrow' />}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="mb-3">
                                    <label htmlFor="paymentDate" className="form-label">{intl.formatMessage({ id: 'INVOICE.MODAL.PAYMENT_DATE' })}</label>
                                    <Flatpickr ref={fppaymentdate}
                                        onChange={onPaymentDateChange}
                                        options={{
                                            dateFormat: "d-m-Y",
                                            maxDate: new Date(),
                                            defaultDate: [new Date()]
                                        }}
                                        className='form-control'
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-end'>
                                <AvField type="hidden" name="id" value={invoice && invoice.id} />
                                <Button color="success" type="submit">{intl.formatMessage({ id: 'INVOICE.SAVE' })}</Button>
                            </Col>
                        </Row>
                    </AvForm>
                </Modal.Body>
                {loading && <Loader></Loader>}
            </Modal>
        )
    }

    const renderSendEmailModal = () => {

        return (
            <Modal centered show={showSendEmailModal} onHide={() => setSendEmailModal(!showSendEmailModal)}>
                <Modal.Header closeButton>
                    <Modal.Title>{intl.formatMessage({ id: 'INVOICE.MODAL.SEND_EMAIL' })}</Modal.Title>
                    <div className="ms-5">
                        <LanguageSelector
                            languages={languages}
                            currentLanguageCode={currentInvoiceEmailLanguageCode}
                            onLanguageChange={handleLanguageChange}
                        />
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <AvForm key={1} onValidSubmit={handleSendEmailSubmit}>
                        <Row>
                            <Col>
                                <AvField name="emailAddress" label={intl.formatMessage({ id: 'INVOICE.MODAL.EMAIL_ADDRESS' })} type="text"
                                    value={invoice?.customer?.email ? invoice.customer.email : invoice?.user?.email} validate={emailValidation} />
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-end'>
                                <AvField type="hidden" name="id" value={invoice && invoice.id} />
                                <Button color="success" type="submit">{intl.formatMessage({ id: 'INVOICE.MODAL.SEND' })}</Button>
                            </Col>
                        </Row>
                    </AvForm>
                </Modal.Body>
                {loading && <Loader></Loader>}
            </Modal>
        )
    }

    const renderProcessPaymentUpdateModal = () => {
        return (
            <Modal centered show={updateProcessPaymentModal} onHide={() => setUpdateProcessPaymentModal(!updateProcessPaymentModal)}>
                <Modal.Header closeButton>
                    <Modal.Title>{intl.formatMessage({ id: 'INVOICE.MODAL.PROCESS_PAYMENT' })}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <AvForm key={1} onValidSubmit={handleUpdateTransactionValidSubmit} ref={(e) => (setTransactionForm(e))}>

                        <Row>
                            <Col>
                                <div className="mb-3">
                                    <label htmlFor="paymentDate" className="form-label">{intl.formatMessage({ id: 'INVOICE.MODAL.PAYMENT_DATE' })}</label>
                                    <Flatpickr ref={fpupdatePaymentdate}
                                        onChange={onUpdatePaymentDateChange}
                                        options={{
                                            dateFormat: "d-m-Y",
                                            maxDate: new Date(),
                                            defaultDate: [processPayment && moment(processPayment.transactionDate).format('DD-MM-YYYY')]
                                        }}
                                        className='form-control'
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-end'>
                                <Button color="success" type="submit">{intl.formatMessage({ id: 'INVOICE.SAVE' })}</Button>
                            </Col>
                        </Row>
                    </AvForm>
                </Modal.Body>
            </Modal>
        )
    }


    return (

        <>
            <PageTitle breadcrumbs={usersBreadcrumbs}>{intl.formatMessage({ id: 'INVOICES.BREADCRUMB.DESCRIPTION' })}</PageTitle>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="d-flex flex-column gap-7 gap-lg-10">
                        <div className="d-flex flex-wrap flex-stack gap-5 gap-lg-10">
                            <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-lg-n2 me-auto">
                                {
                                    tabs.map((tab, index) => (
                                        <PolicyChecker policies={tab.policies}>
                                            <li key={index} className="nav-item">
                                                <a className={`nav-link ${tab.active}`} data-bs-toggle="tab" href={tab.hash} role="tab" aria-selected="true">{tab.name}</a>
                                            </li>
                                        </PolicyChecker>
                                    ))
                                }

                            </ul>
                        </div>
                        <div className="tab-content">
                            <PolicyChecker policies={[enumPolicies.InvoiceRead, enumPolicies.InvoiceWrite, enumPolicies.InvoiceEdit]}>
                                {renderInvoice()}
                            </PolicyChecker>
                            <PolicyChecker policies={[enumPolicies.InvoiceWrite, enumPolicies.InvoiceEdit]}>
                                {renderHistory()}
                            </PolicyChecker>
                        </div>
                    </div>
                </div>
            </div>
            {renderProcessPaymentModal()}
            {renderSendEmailModal()}
            {renderProcessPaymentUpdateModal()}

            {loading && <Loader />}
        </>
    );
};

const mapStateToProps = state => {
    return {
        invoice: state.Invoice.invoice,
        historyList: state.Invoice.historyList,
        processPayment: state.Invoice.processPayment,
        loading: state.Invoice.loading,
        success: state.Invoice.success,
        historyLoading: state.Invoice.historyLoading,
        userList: state.Invoice.userList,
        customerList: state.Invoice.customerList
    };
};

const mapActionsToProps = {
    clearState, getInvoice, getDealers, getCustomers, patchInvoice, postInvoice, putItems, getHistory, postTransaction, postInvoiceEmail, getTransaction, patchTransaction
}

export default connect(mapStateToProps, mapActionsToProps)(Invoice)
